export const chunk = <T>(arr: T[], size: number): T[][] => {
  if (!arr?.length) return [];
  if (size <= 0) throw new RangeError("chunk size must be a positive integer");
  if (arr.length <= size) return [arr];
  const out: T[][] = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
};
